import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import { ANNUAL, MONTHLY } from '../../constans';
import { formatMoney } from '../../utils/Formatter';
import { addDaysToDate, getDaysDifference } from '../../utils/Date';
import { useSessionCheck } from '../../hooks/useSessionCheck';
import { t } from 'i18next';
import { useAppContext } from '../../store/AppContext';


export default function PlanChangeComplete() {
  //useSessionCheck()
  const { state } = useAppContext()
  const { subscription } = state.user
  const plan = sessionStorage.getItem("plan");
  const planData = [{ title: MONTHLY, value: 4.99 }, { title: ANNUAL, value: 49 }]
  const navigate = useNavigate();

  const handleNext = () => {
    window.location.href = "eyeary://Login"
  };

  const handleGoHome = () => {
    navigate('/account')
  };


  function getPlanData() {
    return planData.filter((data) => data.title == plan)[0]
  }

  function trans(key, options) {
    return t("completion_page_" + key, options)
  }

  return (
    <ScreenContainer style={style.container}>
      <Header withBackButton={false} />
      <div className={"scrollContainer"} style={style.scrollContainer}>
        <div className='title title_m_24_medium'>{trans(205)}</div>
        <p className={"description body_15_regular mt-16"}>
          {trans(206)}
        </p>
        <div style={style.card} className='mt-32'>
          <div style={style.cardTitle}>멤버십 요약</div>
          <Row label={trans(172)} value={trans(173, { period: subscription.plan == ANNUAL ? trans('173_2') : trans('173_1') })} />
          <Row label={trans(209)} value={`D-${getDaysDifference(new Date(), subscription.currentPeriodEnd * 1000)}`} />
          <Row label={trans(211)} value={new Date(subscription.currentPeriodEnd * 1000).toLocaleDateString()} />
        </div>
      </div>
      <div className="button-wrapper">
        <Button
          text={trans(167)}
          onClick={handleGoHome}
          className={"primary-on-button primary-button-text"}
        />

        <Button
          text={t("completion_page_168")}
          onClick={handleNext}
          className={"primary-off-button primary-button-text mt-8"}
        />
      </div>

    </ScreenContainer>

  );
}
const Row = ({ label, value }) => {
  return <div style={style.row}>
    <div className='body_14_regular' style={{ color: colors.mono300 }}>{label}: </div>
    <div className='body_14_regular'>{value}</div>
  </div>
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden'
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'scroll'
  },
  card: {
    backgroundColor: '#111D22',
    borderRadius: 20,
    padding: 20,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  cardTitle: {
    ...typography.title.s_18_medium,
    color: '#FFF',
    width: '100%',
    borderBottom: '1px solid #23292E',
    paddingBottom: 8

  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }

}